<template>
  <div class="joinManagement">
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" @click="jump()">{{$t('lang.btn_backActivity')}}</el-button>
      </div>
      <el-table
        :data="tableData"
        class="wid100"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55" v-if="this.seeActivityManagementcheckbox"></el-table-column>
        <el-table-column
          type="index"
          :index="indexMethod" align="center"
          :label="$t('lang.lab_index')"
          width="100px"
        ></el-table-column>
        <el-table-column prop="sname" label="学生姓名"></el-table-column>
        <el-table-column prop="joinPhone" label="家长电话"></el-table-column>
        <el-table-column prop="sch" label="学校名称"></el-table-column>
        <el-table-column prop="subject" label="学习课程"></el-table-column>
        <el-table-column prop="payOrder" label="支付单号"></el-table-column>
        <el-table-column prop="payAmount" label="支付金额">
          <template slot-scope="scope">{{ scope.row.payAmount/100}}</template>
        </el-table-column>
        <el-table-column prop="paySuccessTime" label="支付时间">
          <template slot-scope="scope">{{ scope.row.paySuccessTime | time }}</template>
        </el-table-column>
        <el-table-column label="团长标识" prop="operation">
          <template slot-scope="scope" v-if="groupId==scope.row.joinId">
            <el-tag effect="dark">团长</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
  </div>
</template>

<script>
/**
 *@ClassName:joinManagement
 *@Description:活动管理详情
 *@author:刘彦辰
 *@Copyright:格众科技
 *@date:2020-02-21
 */
export default {
  data () {
    return {
      multipleSelection: [],
      pageCount: 0,
      pageNum: 1,
      pageSize: 10,
      tableData: [],
      groupId: '',
      activityId: '',
      seeActivityManagementcheckbox: require('@/config/enum').seeActivityManagementcheckbox, // 是否隐藏复选框
    }
  },
  created () {
    this.groupId = this.$route.query.groupId
    this.activityId = this.$route.query.activityId
    this.activityList()
  },
  methods: {
    // 列表隔行变色
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
     // ID序号功能
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
     // CHECKBOX
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 活动参团详情列表
    activityList() {
      let loading = this.$loading()
      this.$get(
        `/activitySignByGroupId?isLeader=2&pageSize=${this.pageSize}&pageNo=${this.pageNum}&activityId=${this.activityId}&groupId=${this.groupId}`
      ).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            console.log(res)
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 点击换页
    handleCurrentChange(val) {
      this.pageNum = val
      this.activityList()
    },
    // 返回按钮
    jump() {
      this.$router.push({ name: 'groupManagement', query: { id: this.activityId } })
    },
    // 点击更改每页容量
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.activityList()
    },
  }
}
</script>

<style>

</style>